export default {
	title: 'networks',
	icon: 'far fa-globe',
	components: [
		{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
		{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
		{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
		{ title: 'restrict_login', component: 'restrict_login' },
		{ title: 'cloud', component: 'cloud' },
	],
};
